import { render, staticRenderFns } from "./MembershipItem.vue?vue&type=template&id=00c04655&"
import script from "./MembershipItem.vue?vue&type=script&lang=js&"
export * from "./MembershipItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports